import React from 'react';
import ContentManagement from './ContentManagement';

const ContactContent = () => {
  return <ContentManagement page="contact" />;
};

export default ContactContent;
